import { MasterClassWhereInput } from '@/@generated/codegen/API';
import { useQueryParams } from '@/hooks/useQueryParams';
import { QUERY_PARAM_GLOBAL_FILTER_KEY } from '@/hooks/useTableQueryParamsUtils';
import { parseStringQueryParam } from '@/utils/query-params/parseStringQueryParam';
import { useOrderByQueryParam } from '@/utils/query-params/useOrderByQueryParam';
import { usePaginationQueryParam } from '@/utils/query-params/usePaginationQueryParam';

export const useAdminMasterClassListQueryParams = (pageSize: number, prefix: string) => {
  const queryObject = useQueryParams(
    [QUERY_PARAM_GLOBAL_FILTER_KEY, 'createdAt', 'updatedAt', 'title', 'clientName'],
    prefix
  );
  const { q } = queryObject;

  const orderByArgs = useOrderByQueryParam(prefix);
  const paginationArgs = usePaginationQueryParam(pageSize, prefix);
  const where: MasterClassWhereInput = {
    AND: [
      q
        ? {
            OR: [
              { id: parseStringQueryParam(q) },
              { title: parseStringQueryParam(q) },
              {
                clients: {
                  some: {
                    name: parseStringQueryParam(q),
                  },
                },
              },
            ],
          }
        : {},
      {
        title: parseStringQueryParam(queryObject.title),
      },
      queryObject.clientName
        ? {
            clients: {
              some: {
                name: parseStringQueryParam(queryObject.clientName),
              },
            },
          }
        : {},
    ],
  };

  return {
    paginationArgs,
    orderByArgs,
    where,
  };
};
